import {Table} from "antd";
import {DeployState, DeployStateExt} from "../enums/DeployState";
import React, {useState} from "react";
import {DeployServerInfo} from "../entities/ServiceInfo";
import {DeployServerRecord} from "../entities/DeployRecord";
import {IS_TEST} from "../utils/config";
import DateFormatUtils from "../utils/DateFormatUtils";

interface PickServerTableProps {
    servers: DeployServerInfo[];
    records?: DeployServerRecord[];
    onServerSelected?: (servers: string[]) => void;
}

export const ServerInfoTable: React.FC<PickServerTableProps> = ({ servers, records, onServerSelected }) => {

    const [selectedServerKeys, setSelectedServerKeys] = useState<React.Key[]>(IS_TEST ? servers.map(s => s.instanceId) : []);

    const getDeployRecord = (instanceId: string): DeployServerRecord | undefined => {
        return records?.find(record => record.instanceId === instanceId);
    }
    return (
        <Table
            rowKey={(server) => server.internalIp}
            rowSelection={onServerSelected ? {
                selectedRowKeys: selectedServerKeys,
                onChange: (selectedRowKeys: React.Key[]) => {
                    setSelectedServerKeys(selectedRowKeys);
                    onServerSelected!(selectedRowKeys.map(key => key.toString()));
                },
                getCheckboxProps: (server: DeployServerInfo) => ({
                    disabled: records && getDeployRecord(server.instanceId) !== undefined,
                }),
            } : undefined}
            columns={[
                {
                    title: '机器',
                    dataIndex: 'instanceName',
                    key: 'instanceName',
                    render: (text, server) => `${server.instanceName}@${server.internalIp}`
                },
                records ?
                {
                    title: '部署时间',
                    key: 'deployTimePeriod',
                    render: (text, server) => {
                        const deployRecord = getDeployRecord(server.instanceId);
                        if (deployRecord){
                            if (deployRecord.rollbackState === DeployState[DeployState.PENDING]){
                                return `${DateFormatUtils.format(deployRecord.startTime)} - ${DateFormatUtils.format(deployRecord.finishTime)}`;
                            }
                            return `${DateFormatUtils.format(deployRecord.rollbackStartTime)} - ${DateFormatUtils.format(deployRecord.rollbackFinishTime)}`;
                        }
                        return '';
                    }
                } :
                {
                    title: '最后部署时间',
                    dataIndex: 'deployTime',
                    key: 'deployTime',
                    render: (text) => DateFormatUtils.format(text)
                },
                {
                    title: '状态',
                    dataIndex: 'deployState',
                    key: 'deployState',
                    render: (text, server) => {
                        const deployRecord = getDeployRecord(server.instanceId);
                        if (deployRecord){
                            if (deployRecord.rollbackState === DeployState[DeployState.PENDING]){
                                return DeployStateExt.getDeployStateTextFromString(deployRecord.deployState);
                            }
                            return DeployStateExt.getRollbackStateTextFromString(deployRecord.rollbackState);
                        }
                        return records ? DeployStateExt.getDeployStateText(DeployState.PENDING) : DeployStateExt.getDeployStateTextFromString(text);
                    },
                },
                {
                    title: "访问实例",
                    key: "login",
                    render: (text, record) => <a href={`https://ecs-workbench.aliyun.com/?from=ecs&instanceType=ecs&instanceId=${record.instanceId}&language=zh-CN`} target="_blank">访问</a>
                }
            ]}
            dataSource={servers}
            pagination={false}
        />
    );
}